var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"m-table-cell m-table-cell-spacer",class:{
    'm-table-cell-container_right-border': _vm.hasRightBorder,
    'm-table-cell-container_column-sticked': _vm.isColumnSticked,
    'm-table-cell-container_sticky-column': _vm.sticky,
  },style:(_vm.cssVars)})
}
var staticRenderFns = []

export { render, staticRenderFns }